import gql from "graphql-tag";

export const CREATE_ORGANIZATION = gql`
  mutation AddOrganization($data: OrganizationDataInput) {
    addOrganization(data: $data) {
      id
    }
  }
`;

export const CREATE_ORGANIZATIONS = gql`
  mutation AddOrganizations($data: [OrganizationDataInput]) {
    addOrganizations(data: $data) {
      id
    }
  }
`;

export const UPDATE_ORGANIZATION = gql`
  mutation UpdateOrganization(
    $data: OrganizationDataInput
    $where: OrganizationWhereInput
  ) {
    updateOrganization(where: $where, data: $data) {
      id
    }
  }
`;

export const DELETE_ORGANIZATION = gql`
  mutation DeleteOrganization($where: OrganizationWhereInput) {
    deleteOrganization(where: $where) {
      id
    }
  }
`;

export const IMPORT_ORGANIZATIONS_FROM_FILE = gql`
  mutation ImportOrganizationsFromFile($data: ImportOrganizationsInput) {
    importOrganizationsFromFile(data: $data) {
      id
    }
  }
`;

const organizations = {
  CREATE_ORGANIZATION,
  UPDATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  IMPORT_ORGANIZATIONS_FROM_FILE,
  CREATE_ORGANIZATIONS,
};

export default organizations;
